// Link to the public feedback form. Only the first part of the path is sent
// (for example "dashboard"), never trip ids or anything personal.
export function feedbackUrl() {
  let page = '';
  try { page = (window.location.pathname.split('/')[1] || '').replace(/[^A-Za-z0-9_-]/g, '').slice(0, 40); } catch (e) { /* ignore */ }
  return 'https://flyatlast.com/feedback.html?src=app' + (page ? '&page=' + encodeURIComponent(page) : '');
}
